(function () {
    "use strict";

    angular.module("app").controller("MySigninsController", MySigninsController);

    MySigninsController.$inject = ["controllerDecorator", "infiniteScrollDataSourceFactory", "account"];
    function MySigninsController(controllerDecorator, infiniteScrollDataSourceFactory, account) {
        const vm = this;

        Object.defineProperty(vm, "Filter", { get: () => vm.DataSource.GetFilter() });
        Object.defineProperty(vm, "PageAndSort", { get: () => vm.DataSource.GetPageAndSort() });
        Object.defineProperty(vm, "Signins", { get: () => vm.DataSource.Items() });

        vm.CopyToClipboard = copyToClipboard;

        initialize();

        function initialize() {
            controllerDecorator.Decorate(vm, []);

            vm.DataSource = infiniteScrollDataSourceFactory.Create(account.MySignins, (v) => vm.isLoadingRequests = v);

            vm.PageAndSort.SortBy = [{ Name: "Timestamp", IsReverse: true }];

            vm.DataSource.ResetSearch();

            vm.SetLoadingState(false);
        }

        async function copyToClipboard(event) {
            if (!event)
                return;

            const lines = [
                { Label: "Timestamp", Value: event.Timestamp.toISOString() },
                { Label: "IP", Value: event.IPAddress },
                { Label: "Browser", Value: event.Browser },
                { Label: "OS", Value: event.OperatingSystem }
            ];

            const maxLabelLength = lines.map(l => l.Label.length).sort((l, r) => r - l)[0];

            lines.forEach(l => l.Label = (l.Label + ":").padEnd(maxLabelLength + 1));

            const text = lines.reduce((acc, line) => acc + `${line.Label} ${line.Value}\r\n`, "");

            try {
                await navigator.clipboard.writeText(text);
                vm.ShowSuccess(vm.getTranslation("CopyToClipboard_Success"));
            } catch {
                vm.ShowError(vm.getTranslation("CopyToClipboard_Failed"));
            }
        }
    }
})();
